import React from 'react';

import styled from 'styled-components';
import { Tree } from 'antd';
import 'antd/lib/tree/style/index.css';

const StyledTree = styled(Tree)``;

const TreeSelect = ({ onCheck, treeData, checkedKeys }) => {
  return <StyledTree checkable onCheck={onCheck} treeData={treeData} checkedKeys={checkedKeys} />;
};

export default TreeSelect;
